import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

// contractor category routes
export const addContractorCategoryApi = (data) =>
  axios.post(`${API_BASE_URL}/api/contractor/category/add`, data);

export const getContractorsListApi = (params = {}) =>
  axios.get(`${API_BASE_URL}/api/contractor-categories`, { params });

export const updateContractorCategoryApi = (id, data) =>
  axios.patch(`${API_BASE_URL}/api/contractor-categories/${id}`, data);

export const deleteContractorCategoryApi = (id) =>
  axios.delete(`${API_BASE_URL}/api/contractor-categories/${id}`);

// contractor routes
export const addContractorApi = (data) =>
  axios.post(`${API_BASE_URL}/api/contractor/add`, data);

export const getContractorsApi = (params = {}) =>
  axios.get(`${API_BASE_URL}/api/contractors`, { params });

export const getContractorByIdApi = (id) =>
  axios.get(`${API_BASE_URL}/api/contractor/${id}`);

export const updateContractorApi = (id, data) =>
  axios.patch(`${API_BASE_URL}/api/contractor/edit/${id}`, data);
